import React, { useEffect } from "react";
import { withFormik, Form, Field } from "formik";
import { withAuthentication } from "../../../hoc/withAuthentication";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import * as Yup from "yup";
import Alert from "../../../custom_components/alert";
import { TIMEZONES } from "../../../constants/Timezones";
import ModalWindow from "@/custom_components/ModalWindow";
import { getActiveShop } from "@/constants/utility";

const options = TIMEZONES.map(({ FIELD2, FIELD3, FIELD4 }) => {
  const label = `${FIELD2} ${FIELD3} ${FIELD4}`;
  const value = FIELD3;
  // const disabled = status !== 'Active' ? true : false;
  return { label, value };
});

const Timezone = ({ errors, isSubmitting, setFieldValue, values }) => {
  const defaultValue = options.find(({ label }) => /^United States/i.test(label));

  const timezone = values.timezone && options.find(({ value }) => value == values.timezone);

  useEffect(() => {
    setFieldValue("timezone", timezone?.value || defaultValue.value);
  }, []);
  let render = (
    <ModalWindow className="uk-width-large" overflow={false}>
      {errors.alert && <Alert>{errors.alert}</Alert>}
      {errors.success && <Alert className="uk-alert-success">{errors.success}</Alert>}
      <div className="uk-text-center ">
        <h5 className="uk-padding-small">Please update your shop Timezone.</h5>
      </div>

      <Form className="uk-form-stacked uk-padding-small">
        <div className={"uk-child-width-1-2 uk-grid-small"} uk-grid={1}>
          <div className="uk-width-1-1">
            <label className="uk-form-label" htmlFor="timezone">
              Shop Timezone
            </label>
            <div className="uk-form-controls">
              <Select
                name="timezone"
                options={options}
                // isOptionDisabled={(option) => option.disabled === true}
                onChange={(evt) => {
                  setFieldValue("timezone", evt.value);
                }}
                defaultValue={timezone || defaultValue}
              />
            </div>
          </div>

          <div className="uk-width-1-1 uk-text-center">
            <button type="submit" className="uk-button uk-button-danger uk-width-1-1" disabled={isSubmitting}>
              {isSubmitting ? <i className="fa fa-spinner fa-spin fa-fw"></i> : "Submit"}
            </button>
          </div>
        </div>
      </Form>
    </ModalWindow>
  );

  return render;
};

const FormikTimezone = withFormik({
  mapPropsToValues({ timezone }) {
    return {
      timezone: timezone || "",
    };
  },
  validationSchema: Yup.object().shape({
    timezone: Yup.string().required(),
  }),
  handleSubmit(values, { props, resetForm, setErrors, setSubmitting }) {
    const storeId = props.user.selectedShop;
    props.httpClient
      .put(`/repairshop/updateTimeZone/${storeId}`, values)
      .then((res) => {
        const shop = getActiveShop(props.user);
        props.user.updateShop({ ...shop, ...values });
        // window.location.href = "/";
      })
      .catch((error) => {
        setErrors({ alert: error.response.data });
      })
      .finally((res) => {
        setSubmitting(false);
      });
  },
})(Timezone);

export default withAuthentication(withRouter(FormikTimezone));
